module.exports = __webpack_public_path__ + "static/img/xinnengyuan2.3511b88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xinnengyuan2.png
// module id = BVcG
// module chunks = 16